<div *ngIf="!firmService.isHawaiian()" class="order-now-bar" id="ordernow-footer" [style.color]="firm?.theme.main_gradient_contrast_color">
  <div class="centered">
      <span class="h2">{{ 'DOWNLOAD.ORDER_APP' | translate }}</span>
      <div class="download-buttons">
          <a [href]="firm?.android_app_url" target="_blank"><img src="../../assets/img/download_android.png" alt="Download Android App"></a>
          <a [href]="firm?.ios_app_url" target="_blank"><img src="../../assets/img/download_ios.png" alt="Download iOS App"></a>
      </div>
  </div>
</div>